import type { Phase } from '@/domain/schedule';
import type { Translator } from '@/i18n/useT';

/** The one-line human form of a phase — shared by the group chip and the Now card. */
export function phaseLabel(t: Translator, phase: Phase): string {
  switch (phase.kind) {
    case 'live':
      // Most phases only start and then stay obtainable; only the ones with an
      // end date get a countdown.
      if (phase.daysLeft === null) return t('phase.live');
      return phase.daysLeft === 1 ? t('phase.lastDay') : t('phase.daysLeft', { n: phase.daysLeft });
    case 'upcoming':
      return phase.startsIn === 1
        ? t('phase.startsTomorrow')
        : t('phase.startsIn', { n: phase.startsIn });
    case 'ended':
      return t('phase.ended');
    case 'always':
      return '';
  }
}

/** Chip colours: live is the only state that should catch the eye. */
export function phaseTone(phase: Phase): string {
  return phase.kind === 'live'
    ? 'border-pip-dim bg-pip-faint/30 text-pip'
    : 'border-line text-text-faint';
}
